import React, { useEffect, useRef, useState } from 'react'
import { Button, Empty, Space, Spin } from 'antd'
import { RightOutlined, DownloadOutlined } from '@ant-design/icons'

import Styles from '../create-exam-batch/ExamBatch.module.scss'
import SelectExamRoomAllocationRuleModal from './SelectExamRoomAllocationRuleModal'
import FileDownloadModal from './FileDownloadModal'
import ExaminationLocationTable from './ExaminationLocationTable'

function ExaminationBatchRoomItem ({ batchInfo, updateBatchList, componentType }) {
  const selectExamRoomAllocationRuleModalRef = useRef()
  const fileDownloadModalRef = useRef()
  const [batchItemClass, setBatchItemClass] = useState('')
  const [batchCollapse, setBatchCollapse] = useState(true)
  const [locationList, setLocationList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (batchCollapse) {
      setBatchItemClass([Styles.batchItem, Styles.isCollapseActive].join(' '))
    } else {
      setBatchItemClass(Styles.batchItem)
    }
  }, [batchCollapse])

  const toggleBatchCollapse = () => {
    setBatchCollapse(!batchCollapse)
  }

  const showSelectAllocationRuleModal = () => {
    selectExamRoomAllocationRuleModalRef.current.showModal()
  }

  const saveBatchAllocationRuleSuccess = () => {
    updateBatchList?.()
  }

  const updateLocationList = (list) => {
    setLocationList(list)
  }

  const generateExamLocationContent = (type) => {
    let content
    switch (type) {
      case 3:
        content = (
          <div className={ 'd-flex align-items-center justify-content-center flex-column' }>
            <Empty description={ '' }></Empty>
            <Button
              type={ 'primary' }
              ghost
              onClick={ showSelectAllocationRuleModal }
            >配置分配规则</Button>
          </div>
        )
        break
      case 4:
      case 5:
      case 6:
        content = (
          <ExaminationLocationTable
            batchInfo={ batchInfo }
            componentType={ componentType }
            updateLocationList={ updateLocationList }
          ></ExaminationLocationTable>
        )
        break
    }

    return content
  }

  const downloadBtnVisible = (visible) => {
    if (visible) {
      return (
        <Button
          type={ 'primary' }
          size={ 'small' }
          onClick={ showFileDownloadModal }
        >
          <Space>
            下载
            <DownloadOutlined />
          </Space>
        </Button>
      )
    } else {
      return <></>
    }
  }

  const showFileDownloadModal = (e) => {
    e.stopPropagation();
    fileDownloadModalRef.current.showModal();
  }

  return (<>
    <Spin spinning={ loading }>
      <div className={ batchItemClass }>
        <div className={ Styles.batchItemHeader } onClick={ toggleBatchCollapse }>
          <Space size={ 64 }>
            <div className={ 'text-primary' }>{ batchInfo.batchName }</div>
            <div>
              <span>考生人数：</span>
              <span>{ batchInfo.applyCount }</span>
            </div>
            <div>
              <span>考场标准人数：</span>
              <span>{ batchInfo.standardRoomNumber }</span>
            </div>
            <div>
              <span>考场数：</span>
              <span>{ batchInfo.roomNumber }</span>
            </div>
          </Space>

          <Space size={ 16 }>
            { downloadBtnVisible(batchInfo.generateCandidateNumber === 1) }
            <Button className={ 'ml-3' } size={ 'small' } type={ 'link' }>
              <RightOutlined/>
            </Button>
          </Space>

        </div>
        <div className={ Styles.batchItemBody }>
          { generateExamLocationContent(batchInfo.allocateProgress) }
        </div>

        <SelectExamRoomAllocationRuleModal
          ref={ selectExamRoomAllocationRuleModalRef }
          batchInfo={ batchInfo }
          saveBatchAllocationRuleSuccess={ saveBatchAllocationRuleSuccess }
        ></SelectExamRoomAllocationRuleModal>

        <FileDownloadModal
          ref={ fileDownloadModalRef }
          batchInfo={ batchInfo }
          locationList={ locationList }
        />
      </div>
    </Spin>
  </>)
}

export default ExaminationBatchRoomItem
